import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import Header from '../../../components/Header';
import ApplicationId from '../../../components/ApplicationId';
import Transition from '../../../components/Transition';
import ContentWrapper from '../../../components/ContentWrapper';

import './style.scss';

const ThankYou = () => {
  const checkinData = useSelector((state) => state.screen.checkinData);
  const firstName = get(checkinData, 'data.data.applicant.firstName', '')
    || get(checkinData, 'state.data.applicant.firstName', '')
    || get(checkinData, 'state.data.firstName', '');

  return (
    <div className="debit-card-election autopay-election-page dponly-payment-page">
      <Transition className="transition-item wrapper v-center">
        <Header />
        {get(checkinData, 'attributes.entityId') ? (
          <ApplicationId id={get(checkinData, 'attributes.entityId')} style={{ marginTop: 10, marginBottom: 4 }} />
        ) : null}
        <hr className="separator pt-20" />
        <ContentWrapper className="debit-card-election-content">
          <div className="thank-you-page">
            <div className="thank-you-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3989E3" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="4 12.5 9.5 18 20 6.5" />
              </svg>
            </div>
            <h2 className="thank-you-title">
              Thank you
              {firstName ? `, ${firstName}` : ''}
            </h2>
            <p className="thank-you-subtitle">No further action is needed at this time.</p>

            <div className="thank-you-next-steps">
              <h3 className="next-steps-title">What happens next</h3>
              <div className="next-steps-list">
                <div className="next-step-item">
                  <span className="step-number">1</span>
                  <span className="step-text">Please allow 3 business days to process and confirm your down payment.</span>
                </div>
                <div className="next-step-item">
                  <span className="step-number">2</span>
                  <span className="step-text">You will receive an email receipt.</span>
                </div>
                <div className="next-step-item">
                  <span className="step-number">3</span>
                  <span className="step-text">We will send you a text and email when your contract is ready for signature.</span>
                </div>
              </div>
            </div>

            <p className="thank-you-contact">
              Questions about your down payment? Call us at (800) 697-8743.
              <br />
              <br />
              Hours of Operation:
              <br />
              Monday - Friday 7:00 AM - 8:00 PM Pacific Time
              <br />
              Saturday - Sunday 9:00 AM - 8:00 PM Pacific Time
            </p>
          </div>
        </ContentWrapper>
      </Transition>
    </div>
  );
};

ThankYou.propTypes = {};

export default ThankYou;
